module.exports = __webpack_public_path__ + "static/media/campaign.f15388bb.svg";